<script lang="ts">
  import Icon, { type IconName } from './Icon.svelte';

  export interface CtxItem {
    label: string;
    icon?: IconName;
    danger?: boolean;
    onClick: () => void;
  }

  let {
    x,
    y,
    title,
    items,
    onClose,
  }: {
    x: number;
    y: number;
    title?: string;
    items: CtxItem[];
    onClose: () => void;
  } = $props();

  // ghim trong viewport
  const W = 210;
  const H = $derived(52 + items.length * 42);
  const left = $derived(Math.max(8, Math.min(x, window.innerWidth - W - 8)));
  const top = $derived(Math.max(8, Math.min(y, window.innerHeight - H - 8)));
</script>

<div
  class="ctx-scrim"
  role="presentation"
  onpointerdown={onClose}
  oncontextmenu={(e) => {
    e.preventDefault();
    onClose();
  }}
></div>
<div class="ctx-menu" style="left:{left}px; top:{top}px" role="menu">
  {#if title}<div class="ctx-title">{title}</div>{/if}
  {#each items as it (it.label)}
    <button
      class="ctx-item"
      class:danger={it.danger}
      role="menuitem"
      onclick={() => {
        it.onClick();
        onClose();
      }}
    >
      {#if it.icon}<Icon name={it.icon} size={16} />{/if}<span>{it.label}</span>
    </button>
  {/each}
</div>

<style>
  .ctx-scrim {
    position: fixed;
    inset: 0;
    z-index: var(--z-modal);
    background: transparent;
  }
  .ctx-menu {
    position: fixed;
    z-index: var(--z-modal);
    min-width: 190px;
    padding: 6px;
    background: var(--color-surface);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-control);
    box-shadow: var(--shadow-panel);
  }
  .ctx-title {
    padding: 6px 10px;
    font-size: var(--font-size-caption);
    font-weight: 700;
    color: var(--color-text-secondary);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-bottom: 1px solid var(--color-border);
    margin-bottom: 4px;
  }
  .ctx-item {
    display: flex;
    align-items: center;
    gap: var(--space-sm);
    width: 100%;
    min-height: 38px;
    padding: 0 10px;
    border: none;
    border-radius: 8px;
    background: transparent;
    color: var(--color-text-primary);
    font: inherit;
    font-weight: 600;
    text-align: left;
    cursor: pointer;
  }
  .ctx-item:hover {
    background: var(--color-canvas-bottom);
    color: var(--color-primary);
  }
  .ctx-item.danger:hover {
    background: var(--color-error-bg, #fdecec);
    color: var(--color-error);
  }
</style>
